module.exports = __webpack_public_path__ + "img/map_1791445010602_46600.4c464b6a.jpg";